(function (ws) {
    'use strict';
    ws.collections.modalTableCollection = Backbone.Collection.extend({

        /**
         * Initialize function
         */
        initialize: function() {
            this.model = ws.models.modalTableProductModel;
            this.eventAgg = globals.eventAgg;
        },

        /**
         * gets checked items from the collection
         */
        getSelectedItems: function() {
            let modelParentMapping = {};
            let models = this.models;
            this.models.forEach(row => {
                if (row.get('childs')) {
                    row.get('childs').forEach(rowId => {
                        modelParentMapping[rowId] = row.get('id');
                    });
                }
            });

            return _.filter(this.models, function(item) {
                //Keeping console log to test in qa
                console.log(item.get('id') + '->>>' + (item.get('checked') === true || (['VIC', 'VIP'].includes(item.get('type')) && item.attributes.hasOwnProperty('checked') === false && models[modelParentMapping[item.get('id')]] && models[modelParentMapping[item.get('id')] - 1].get('checked')) && (!item.get('disable') || ([true, 'true'].includes($('#mitelSubscriptionOrder').val())))));
                return (item.get('checked') === true || (['VIC', 'VIP'].includes(item.get('type')) && item.attributes.hasOwnProperty('checked') === false && models[modelParentMapping[item.get('id')]] && models[modelParentMapping[item.get('id')] - 1].get('checked')) && (!item.get('disable') || ([true, 'true'].includes($('#mitelSubscriptionOrder').val()))));
            });
        },

        getSelectedItemsForSelectAllCheckbox: function () {
            let modelParentMapping = {};
            this.models.forEach(row => {
                if (row.get('childs')) {
                    row.get('childs').forEach(rowId => {
                        modelParentMapping[rowId] = row.get('id');
                    });
                }
            });

            return _.filter(this.models, function(item) {
                return (item.get('checked') === true);
            });
        },

        /**
         * parse collection to array of ids to match API request
         */
        toAPI: function() {
            var ids = [];

            _.each(this.getSelectedItems(), function(item) {
                ids.push(item.get('id'));
            });

            return ids;
        }

    });
})(westcon);
